import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Avatar from '@mui/material/Avatar';
import { useSelector } from 'react-redux';

import Tooltip from '@mui/material/Tooltip';
import AppBarMenu from './AppBarMenu';
import SideBarMenu from './SideBarMenu';
import configureMemu from "./configMenu";

import SnackToase from './SnackToast'
import {Link as RouterLink} from 'react-router-dom';


import UserAvatar from './UserAvatar'
import {useAppAuthContext} from '../utils/AppAuthContext'
import {usePlayContext} from '../utils/PlayContext'

import PendingRequestBadge from './PendingRequestBadge'
import LoadingBackDrop from './LoadingBackDrop';
import ErrorPrompt from './ErrorPrompt'
import PageTitle from './PageTitle'

import {  
  selectAllFloors,
  //selectSiteById,
  //selectSiteIds,
}  from '../store/floorSlice'

import headerLogo from '../media/NEC.png'

const systemTitle = "NEC Visitor Management System"


const HeaderBar = () => {

  const {userInfo, loginComplete, tenantName,tenantLogo} = useAppAuthContext()
  const {status,   errorMessage,  errorTitle, } = usePlayContext()
  

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
 
  const floors = useSelector(selectAllFloors);
  const roles = userInfo?.idTokenClaims?.roles
  const menuContents = loginComplete ? configureMemu(roles, floors) :null
  
  

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  

  return (
    <React.Fragment>
      
    <AppBar position="static" sx={{ p:0, m:0,bgcolor:"#160032"}}>
      <Container  maxWidth='false' sx={{ p:0}} >
      { loginComplete &&
        <Toolbar disableGutters variant="dense" 
                sx={{minHeight:34,  pt:2, pb:0,  pl:3,
                  display: {xs:'none', md:'flex'},
                  
                }}>

              <img src={headerLogo}  width='156' height='32'  
                sx={{display:{xs:'none', sm:'block'}}}  />
                {/* <Avatar 
                     sx={{ height: 32, width: 32, mr:2 }}
                    ><img src={tenantLogo}  width='32' height='32' 
                    />
                  </Avatar>
         */}
              <Typography variant='h6' 
              sx={{display:{xs:'block', sm:'none'}}}>
                    NEC 
              </Typography>

        </Toolbar>
        }
        <Toolbar disableGutters variant="dense"
              sx={{minHeight:34,p:0}}
            >

           { loginComplete &&
              <Box sx={{ flexGrow: 0, 
                  display: { xs: 'flex', md: 'none' }, p:0, m:0 }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  //keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    
                    display: { xs: 'block', md: 'none' },
                    fontWeight:800,
                  }}
                >
                  { 
                    menuContents.map((page) => (
                      <SideBarMenu menu={page} 
                          handleCloseSideBar={handleCloseNavMenu} key={page.id}/>
                  ))}
                </Menu>
              </Box>
            }
            
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none'},   }}>
                  <Typography
                      variant="h6"

                      sx={{ flexGrow: 1,  alignItems:'center',  textAlign:'center',
                            }}
                  >
                   <img src={headerLogo}  width='156' height='32'  />
              
                  </Typography>

            </Box>
            

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex',},
             fontWeight:600 , }}>
            
              { loginComplete &&
                menuContents.map((menu, index) => (
                  (!menu.divider) &&  <AppBarMenu key={menu.id} menu={menu} />
                ))
              }
              { !loginComplete &&
                /* aaaaaaaaa   ***/
                <>
                  <Typography variant='h6' 
                      sx={{ml:3, bgcolor:'none', width:'100%',
                            textAlign:'center'}}>
                    {systemTitle}
                  </Typography>

                </>
              }

              
          </Box>

        <Box sx={{ flexGrow: 0 }}>
          { loginComplete &&
            <>
            { roles&&
            roles.includes('HOST') &&
            <Tooltip title="Pending Requests">
                <IconButton
                    sx={{marginRight:'12px'}}
                    size="large"
                    aria-label="show 17 new notifications"
                    color="inherit"
                    component={RouterLink}
                    to={'/request'}
                    >
                  <PendingRequestBadge/>
                </IconButton>
            </Tooltip>
            }
            <Tooltip title={userInfo.name +' ('+roles+')'}>
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <UserAvatar alt={"aaa"} name={userInfo.name} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
                <MenuItem key={'item_k3'} onClick={handleCloseUserMenu}
                    component={RouterLink} to={'/logout'}
                    >
                  <Typography textAlign="center">Logout</Typography>
                </MenuItem>
                
              
            </Menu>
          </>}
          
          </Box>

        </Toolbar>
      </Container>
    </AppBar>
    <SnackToase/>
    <LoadingBackDrop open={status==='loading'||status==='processing'}/>
    { (Boolean(errorMessage) && status==='error') &&
          <ErrorPrompt title={errorTitle} message={errorMessage} 
          />
    }
    { loginComplete &&
      <PageTitle/>  
    }



    </React.Fragment>
  );
};
export default HeaderBar;
